import React from 'react';
import styled from "@emotion/styled";
import profileImage from "../ABOUT_CL.jpg";

const AboutPageContainer = styled("div")({
    // padding: "20px",
  })

export const About = () => {
    return (
        <AboutPageContainer className="About container col-xl-10 col-xxl-8 px-4 py-5">
            <div className="row g-lg-5">
                <div className="col-lg-7 py-2">
                    <div className="container-fluid">
                        <p className="col-md-8 fs-6"><span className="fw-bold">Limke Tax & Consulting, LLC (LTC)</span> is a small business providing tax services in Colorado for those who seek a professional approach with a personal level of service. LTC is owned and operated by Chelsea Limke with the objective to provide accurate and dependable tax services for you and your small business.
                        </p>
                        <p className="col-md-8 fs-6">
                        Chelsea is a Certified Public Accountant and holds a Bachelors in Accounting from California Lutheran University and a Masters in Taxation from the University of Denver. Chelsea has over 10 years of experience, specializing in State and Local Tax. She has experience preparing tax returns (income tax and sales tax) and providing various tax consulting services. She has worked for several large accounting firms including Moss Adams, CBIZ and Grant Thornton.   
                        </p>
                        <p className="col-md-8 fs-6">
                        Chelsea is originally from the Denver metro area and currently resides in Morrison with her family.
                        </p>
                        <button className="btn btn-outline-info btn-lg px-4 me-sm-3 fw-bold" type="button" onClick={() => window.location.href='/Contact'}>Contact Us</button>
                    </div>
                </div>
                <div className="col-md-10 mx-auto col-lg-5 py-2">
                <img src={profileImage} style={{borderRadius: "20px"}} className="d-block mx-lg-auto img-fluid" alt="Chelsea Profile" width="700" height="500" loading="lazy"/>
                </div>
            </div>
        </AboutPageContainer>
    )
}